import { useContext, useEffect, useRef } from "react";
import axios from "axios";
import { API_BASE_URL } from "@config/config";
import { AuthContext } from "@context/AuthContext";

const HEARTBEAT_INTERVAL = 5 * 60 * 1000; // 5 minutes

const SessionHeartbeat = () => {
    const { logout, user } = useContext(AuthContext);

    const startedRef = useRef(false);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (user) {
            if (startedRef.current) return;
            startedRef.current = true;

            const checkSession = async () => {
                try {
                    await axios.get(`${API_BASE_URL}/auth/heartbeat`);
                } catch (error) {
                    if (error.response?.status === 401) {
                        logout();
                    }
                }
            };

            checkSession();
            intervalRef.current = setInterval(
                checkSession,
                HEARTBEAT_INTERVAL
            );

            return () => {
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
                startedRef.current = false;
                };
        }
    }, [logout]);

    return null;
};

export default SessionHeartbeat;
